"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = QuizTrainingStatistic;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _QuizTrainingStatistic = _interopRequireDefault(require("./QuizTrainingStatistic.scss"));

var _index = _interopRequireDefault(require("../Button/index"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _QuizStrings = require("./QuizStrings");

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _QuizRoundStyle = require("./styles/QuizRoundStyle");

function QuizTrainingStatistic(props) {
  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      text = _useState2[0],
      setText = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      totalPoints = _useState4[0],
      setTotalPoints = _useState4[1];

  (0, _react.useEffect)(function () {
    var correctAnswers = 0;
    var temptTotalPoints = 0;
    props.answers.forEach(function (answer) {
      if (answer.isCorrect) {
        correctAnswers++;
      }

      temptTotalPoints = temptTotalPoints + answer.score;
    });

    if (correctAnswers / props.answers.length * 100 >= props.percentageCorrect) {
      setTotalPoints(Math.max(temptTotalPoints, 0));
    } else {
      setTotalPoints(0);
    }
  }, []);
  var dynamicStyle = (0, _QuizRoundStyle.getHeaderStyles)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: '100%',
      width: '100%',
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _QuizTrainingStatistic["default"].feedBackContainer,
    style: dynamicStyle.statsHeaderStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _QuizTrainingStatistic["default"].pointsContainer,
    style: totalPoints === 0 ? dynamicStyle.statsWrongStyle : dynamicStyle.statsCorrectStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _QuizTrainingStatistic["default"].feedbackPoints,
    style: totalPoints === 0 ? dynamicStyle.statsWrongStyle : dynamicStyle.statsCorrectStyle
  }, totalPoints), /*#__PURE__*/_react["default"].createElement("div", {
    className: _QuizTrainingStatistic["default"].feedbackPointsText
  }, "Punkte"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _QuizTrainingStatistic["default"].listContainer
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], null, props.answers.map(function (result, i) {
    console.log('quiztrainingstatistic', result); // @ts-ignore

    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      className: _QuizTrainingStatistic["default"].listItem,
      key: i,
      button: true,
      divider: true,
      onClick: function onClick() {
        return props.goToAnswer(i);
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      className: _QuizTrainingStatistic["default"].listItemText
    }, "Frage ".concat(i + 1)), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      className: _QuizTrainingStatistic["default"].listItemText
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _QuizTrainingStatistic["default"].listItemImgContainer,
      style: result.isCorrect ? dynamicStyle.statsCorrectStyle : dynamicStyle.statsWrongStyle
    }, result.isCorrect ? /*#__PURE__*/_react["default"].createElement(_Done["default"], {
      className: _QuizTrainingStatistic["default"].listItemImg,
      style: {
        color: dynamicStyle.statsCorrectStyle.color
      }
    }) : /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      className: _QuizTrainingStatistic["default"].listItemImg,
      style: {
        color: dynamicStyle.statsWrongStyle.color
      }
    }))), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      className: _QuizTrainingStatistic["default"].listItemText
    }, "".concat(result.score, " ").concat(Math.abs(result.score) === 1 ? 'Punkt' : 'Punkte')));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _QuizTrainingStatistic["default"].buttonContainer
  }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
    className: "".concat(_QuizTrainingStatistic["default"].button, " button"),
    onClick: props.goHome
  }, (0, _QuizStrings.getString)('REVANCHE'))));
}